import React, { useEffect, useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { connect } from 'react-redux';
import { type PostConsentPayload, useConsent } from '@carvana/core-consent';
import Toggle from '../Toggle';
import { notificationSettingsOperations, notificationSettingsSelectors } from '../../ducks';
import {
  NotificationsWrapper,
  HeaderAlt,
  TitleWrapper,
  Title,
  Description
} from '../ShowNotificationSettings.styles';
import type { RootState } from '../../../../store/types';

type OwnProps = {
  trackEventable: (message: boolean, customAttributes: Record<string, string>) => void;
};

type StateProps = {
  isSoftpullConsent: boolean;
};

type DispatchProps = {
  updateCreditMonitoringConsent: (
    postConsent: (request: PostConsentPayload[]) => Promise<unknown>,
    creditMonitoringConsent: boolean
  ) => void;
};

function CreditMonitoring({
  trackEventable,
  isSoftpullConsent,
  updateCreditMonitoringConsent
}: OwnProps & StateProps & DispatchProps) {
  const { consentHtml, postConsent, triggerConsentEvents } = useConsent();
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    triggerConsentEvents('CreditMonitoring', (eventData) => {
      trackEvent(
        `user platform - account - notifications - displayed default creditmonitoring`,
        eventData
      );
    });
  }, []);

  const setCreditMonitoringConsent = () => {
    const creditMonitoringConsent = !isSoftpullConsent;

    updateCreditMonitoringConsent(postConsent, creditMonitoringConsent);
  };

  return (
    <NotificationsWrapper margin="22px 0 0" data-testid="creditmonitoring-section">
      <HeaderAlt>
        <TitleWrapper>
          <Title>Credit Monitoring</Title>
        </TitleWrapper>
        <Toggle
          dataQa="creditmonitoring-toggle"
          value={isSoftpullConsent}
          onClick={() => {
            trackEventable(!isSoftpullConsent, { consentType: 'softpull-credit-monitoring' });
            setCreditMonitoringConsent();
          }}
        />
      </HeaderAlt>
      <Description dangerouslySetInnerHTML={{ __html: consentHtml?.CreditMonitoring?.html }} />
    </NotificationsWrapper>
  );
}

const mapDispatchToProps = {
  updateCreditMonitoringConsent: notificationSettingsOperations.updateCreditMonitoringConsent
};

const mapStateToProps = (state: RootState) => ({
  isSoftpullConsent: notificationSettingsSelectors.getSoftpullConsent(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditMonitoring);
